<template>
  <div class="comp">
    <div class="grid help">
      <el-tooltip class="item" effect="dark" content="Aiuto" placement="top">
        <a href="https://blog.ombrelleria.com/modifica-la-tua-spiaggia-in-ombrelleria/" target="new">
          <unicon name="question-circle" height="24" width="24" fill="#fff" />
        </a>
      </el-tooltip>
    </div>
    <div class="grid dashboard comp-inner">

    <div class="grid header" v-if="grid.length > 0">
        <div class="grid sectiontitle"><span @click="show('dashboard')"><unicon name="arrow-left" height="32" width="32" /></span>Modifca spiaggia</div>
        <div class="grid settings">
          <div class="grid">
            <button class="btn blue sm" v-if="selectedOmbrellos.length > 1" @click="editseat.open = true, editseat.multiple = true"><unicon name="book-medical" fill="#fff" /> crea segmento</button>
          </div>
          <div class="grid">
            <small style="font-size: 7px; line-height: 8px; padding-left: 2px;">righe</small>
            <el-tooltip manual content="clicca qui per aggiungere righe" placement="left" :value="addrow">
              <el-input-number v-model="hotel.rows" @change="changeGridRows2" :min="1" ></el-input-number>
            </el-tooltip>
          </div>
          <div class="grid">
            <small style="font-size: 7px; line-height: 8px; padding-left: 2px;">colonne</small>
            <el-tooltip manual content="clicca qui per aggiungere colonne" placement="bottom" :value="addrow">
              <el-input-number v-model="hotel.cols" @change="changeGridCols2" :min="1" ></el-input-number>
            </el-tooltip>
          </div>
        <transition-group name="slide-fade" class="grid" style="grid-auto-flow: column; grid-column-gap: 12px;">
          <button @click="editsegment.open = true" class="btn sm" v-loading="hotelloading" key="editsegment" v-if="$store.state.hotels.activehotel.cashier && $store.state.hotels.activehotel.segments.length > 1"><unicon name="save" fill="#fff" /> Modifica segmenti</button>
          <button @click="warning ? warningdialog = true : save()" :disabled="!changes" class="btn green sm" v-loading="hotelloading" key="save"><unicon name="save" fill="#fff" /> Salva modifiche</button>
          <!-- <button v-if="selectedOmbrellos.length > 1" class="btn red" v-loading="hotelloading" key="cahnge"><unicon name="save" fill="#fff" /> cambia qualcosa</button> -->
          <!-- <button @click="selection.clearSelection()" key="deselect">deselect</button> -->
        </transition-group>
        <button @click="openmenu()" class="btn"><i class="fas fa-bars"></i></button>
        </div>
    </div>

    <!-- <p>{{firsttime}}</p> -->
    <!-- <p>{{hotel}}</p> -->

      <div class="grid firstgrid" style="justify-items: center;" v-if="$store.state.ombrelloni.ombrelloni.length === 0">
          
          <h1>Aggiungi il tuo primo ombrellone</h1>

          <p>inserisci la denominazione del primo ombrellone a sinistra in fronte mare (es. A1)</p>

          <div class="grid seats">
            <div class="grid seat empty" id="first">
              <el-form key="form" ref="newseatform" :rules="rules" :model="newseat">
                <el-form-item key="ombrid" prop="ombrid" :show-message="false" :inline-message="true">
                    <el-input type="text" v-model="newseat.ombrid" name="ombrid" ref="firstombrid" placeholder="A1"></el-input>
                </el-form-item>
              </el-form>              
            </div>
            <div class="grid seat empty" id="second"></div>
            <div class="grid seat empty" id="third"></div>
            <div class="grid seat empty" id="fourth"></div>
          </div>

          <div class="grid btnlist" key="btnlist">
            <button class="btn" @click="$emit('close')"><unicon name="times" height="16" width="16" fill="#333"  /></button>
            <button class="btn green" @click="addFirstseat('newseatform')">Aggiungi ombrellone</button>
          </div>

      </div>


    <div class="grid beach" v-if="$store.state.ombrelloni.ombrelloni.length > 0">
      
      <!-- {{selectedOmbrellos.length}} -->
      <!-- {{grid}} -->

        <div class="grid beach-inner" :style="style" >
          <div class="grid" style="grid-auto-flow: column; grid-auto-columns: 1fr; grid-column-gap: 32px;" v-for="(row, index) in grid" :key="index" >
            <div class="grid seat editseat" v-for="(ombrellone, index) in row" :key="index" :class="{new: ombrellone.new, notvisible: !ombrellone.visible}" @click="selectedOmbrellos.length > 1 ? (seat = ombrellone, editseat.open = true, editseat.multiple = true) : (seat = ombrellone, editseat.open = true)" :data-ombrid="ombrellone.ombrid" :data-id="ombrellone._id" :style="ombrellone._id|segmentstyle($store.state.hotels.activehotel)">
            <!-- <div class="grid seat editseat" v-for="(ombrellone, index) in row" :key="index" :class="{new: ombrellone.new}" @click="nothing()" :data-ombrid="ombrellone.ombrid" :data-id="ombrellone._id"> -->
              <span class="grid id">{{ombrellone.ombrid}}</span>
              <!-- <span>| {{ombrellone.sortorder}} - {{index}}</span> -->
            </div>
          </div>
        </div>

        <!-- {{style}} -->

<!--         <div class="grid beach-inner" :style="style" v-if="changes" >
          <div class="grid seat editseat" v-for="(ombrellone, index) in newombrelloni" :key="index" >
            <span class="grid id">{{ombrellone.ombrid}}</span>
            <span>| {{ombrellone.sortorder}} - {{index}}</span>
          </div>
        </div> -->


    </div>
    <span id="bottom"></span>
    </div>

    <el-dialog
        title=""
        :visible.sync="editsegment.open"
        width="fit-content"
        :show-close="true"
        custom-class="editsegments"
        destroy-on-close>
        <template slot="title">
          <div class="grid header">
            <div class="title" style="font-size: 20px; margin-right: 48px;">Modifica segmenti</div>
          </div>
        </template>
        <Editsegments @close="editsegment.open = false"></Editsegments>
      </el-dialog>

    <el-dialog
        title=""
        :visible.sync="editseat.open"
        width="fit-content"
        :show-close="true"
        custom-class="editseats"
        destroy-on-close>
        <template slot="title">
          <div class="grid header">
            <!-- <div class="title" v-if="!checkDay(seat.guests)">{{seat.ombrid}}</div> -->
            <div class="title" style="font-size: 20px;">{{selectedOmbrellos.length === 1 ? 'Modifica ombrellone' : 'Crea Segmento'}}</div>
            <!-- <div><small>le modifiche verranno apportate a tutti gli ombrelloni selezionati</small></div> -->
            <!-- <unicon name="draggabledots" height="24" width="24" fill="#fff" /> -->
            <!-- <div class="grid oval" :class="{ active: checkDay(seat.guests), free: !checkDay(seat.guests) }"></div> -->
          </div>
        </template>
          <Editseat
          :seat="seat"
          :seats="selectedOmbrellos"
          :firsttime="firsttime"
          @closeseatDialog="closeseatDialog()"
          @save="save(), editseat.open = false"
          ></Editseat>
      </el-dialog>

      <el-dialog
        title=""
        :visible.sync="newseat.error"
        width="fit-content"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        custom-class="needstoconvert">
        <template slot="title">
          <div class="grid header">
            <div class="title" style="font-size: 20px;">Oh boy</div>
          </div>
        </template>
        <div>
            <h3>Uh, spiacenti</h3>
            <div class="spacer xs"></div>
            <p>Prego inserisci almeno due caratteri come ID</p>
            <!-- <span class="btn reddark sm"><unicon name="thumbs-up" fill="#fff" /> ok, se proprio doviamo</span> -->
            <div class="grid actions" style="grid-auto-flow: column; padding: 0; margin-top: 64px; justify-content: end; grid-column-gap: 24px;">
              <span @click="newseat.error = false" class="btn reddark sm"><unicon name="thumbs-up" fill="#fff" /> ok</span>
            </div>
        </div>
    </el-dialog>

    <el-dialog
        title=""
        :visible.sync="warningdialog"
        width="fit-content"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        custom-class="needstoconvert">
        <template slot="title">
          <div class="grid header">
            <div class="title" style="font-size: 20px;">Attenzione</div>
          </div>
        </template>
        <div>
            <h3>Attenzione</h3>
            <div class="spacer xs"></div>
            <p>Alcuni dati precedentemente inseriti potrebbero andare persi cancellando le file selezionate.</br>
            In caso di errata cancellazione di dati importanti ti preghiamo di contattare il supporto (info@ombrelleria.com).</br>
            Insieme riusciremo a risolvere il problema.</p>
            <div class="grid actions" style="grid-auto-flow: column; padding: 0; margin-top: 64px; justify-content: end; grid-column-gap: 24px;">
              <span class="btn secondary light sm" @click="warningdialog = false, $emit('open', 'dashboard')">cancella modifiche</span>
              <span @click="save(), warningdialog = false" class="btn reddark sm"><unicon name="thumbs-up" fill="#fff" /> ok, procedi</span>
            </div>
        </div>
    </el-dialog>

  </div>
</template>

<script>
import _ from 'lodash'
// import moment from 'moment'
import Editseat from '@/components/Editseat.vue'
import Editsegments from '@/components/micro/Editsegments.vue'
import helper from '../Mixins/helper'
import * as Selection from '@simonwep/selection-js'
import options from '../selectionoptions' // import options for selection.js
export default {
  name: 'Editgrid',
  mixins: [helper],
  props: {
    hotel: Object
  },
  data () {
	return {
      changes: false,
      warning: false,
      warningdialog: false,
      firsttime: false,
      newseat: {
        ombrid: '',
        error: false
      },
      editseat: {
        open: false,
        multiple: false
      },
      editsegment: {
        open: false
      },
      seat: '',
      // hotel: '',
      newombrelloni: [],
      grid: [],
      alphabet: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'z'],
      alphabetde: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'],
      selectedOmbrellos: [],
      rules: {
          ombrid: [
              { required: true, message: 'prego inserisci almeno 2 caratteri', trigger: 'blur' },
              { min: 2, message: 'prego inserisci almeno 2 caratteri', trigger: 'blur' }
        ]
      }
    }
  },
  components: {
    Editseat,
    Editsegments
  },
  methods: {
    closeseatDialog () {
      this.editseat.open = false
      this.grid = _.chunk(this.ombrelloni, this.hotel.cols)
    },
    addFirstseat (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.newseat.error = false
          console.log('good to go: ', this.newseat.ombrid.split(/([aA-zZ]+)([0-9]+)|([0-9]+)([aA-zZ]+)/).filter((el) => { return (el && el.length > 0) }))
          var id = this.newseat.ombrid.split(/([aA-zZ]+)([0-9]+)|([0-9]+)([aA-zZ]+)/).filter((el) => { return (el && el.length > 0) })
          console.log(id)
          console.log(id[0].toUpperCase() + (id[1] ?? ''))
          this.newseat.ombrid = id[0].toUpperCase() + (id[1] ?? '')
          this.$store.commit('ombrelloni/SET_FIRST_SEAT', this.newseat)
          this.firsttime = true
          this.grid = _.chunk(this.ombrelloni, this.hotel.cols)
        } else {
          console.log('error submit')
          this.newseat.error = true
        }
      })
    },
    nothing () {
      console.log(this.selectedOmbrellos)
    },
    checkGrid () {
      // console.log(this.ombrelloni[0].ombrid, this.ombrelloni[1].ombrid, this.ombrelloni[this.hotel.cols].ombrid)
      // var one = this.ombrelloni[0].ombrid
      // // var two = this.ombrelloni[1].ombrid
      // var three = this.ombrelloni[this.hotel.cols].ombrid
      // // var scheme
      // var coldir = one.split(/([aA-zZ]+)([0-9]+)/).filter((el) => { return el.length > 0 })
      // var rowdir = three.split(/([aA-zZ]+)([0-9]+)/).filter((el) => { return el.length > 0 })
      // console.log('coldir: ', coldir)
      // console.log('rowdir: ', rowdir)
    },
    changeGridCols2 (newval, oldval) {
      // var self = this
      // console.log('c 2: ', oldval, newval, _.subtract(newval, oldval))
      this.changes = true
      var self = this
      // console.log("A12".split(/([aA-zZ]+)([0-9]+)/).filter((el) => { return el.length > 0 }))
      _.forEach(this.grid, function (row) {
        console.log('last: ', row, oldval, row[oldval - 1].ombrid.split(/([aA-zZ]+)([0-9]+)|([0-9]+)([aA-zZ]+)/).filter((el) => { return (el && el.length > 0) }))
        var lastid = row[oldval - 1].ombrid.split(/([aA-zZ]+)([0-9]+)|([0-9]+)([aA-zZ]+)/).filter((el) => { return (el && el.length > 0) })
        if (_.subtract(newval, oldval) > 0) {
          _.forEach(_.range(oldval, newval), function (v, i) {
            // console.log(lastid[0] + (parseInt(lastid[1]) + (i + 1)))
            var ombrid
            if (lastid.length > 1) {
              if (isNaN(lastid[0]) && !isNaN(lastid[1])) { 
                ombrid = lastid[0] + (parseInt(lastid[1]) + (i + 1))
              }
              if (!isNaN(lastid[0]) && isNaN(lastid[1])) {
                // console.log('inverted')
                var idindex = _.findIndex(self.alphabet, function (l) { return l == lastid[1].toLowerCase() })
                // console.log(idindex, idindex + 1)
                ombrid = parseInt(lastid[0]) + self.alphabet[idindex + 1].toUpperCase()
              }
            } else {
              if (!isNaN(lastid[0])) { 
                ombrid = (parseInt(lastid[0]) + (i + 1)).toString()
              }
              if (isNaN(lastid[0])) { 
                ombrid = (lastid[0] + (i + 1)).toString()
              }
              // ombrid = 1
            }
            row.push({ombrid: ombrid, new: true})
          })
        } else {
          console.warn('neg number')
          self.warning = true
          _.forEach(_.range(oldval, newval), function () {
            row.pop()
          })
        }
      })
    },
    changeGridRows2 (newval, oldval) {
      location.href = '#bottom'
      var self = this
      this.changes = true
      console.log('r 2: ', oldval, newval)
      if (_.subtract(newval, oldval) > 0) {
        _.forEach(_.range(oldval, newval), function (v, i) {
          // console.log(v, i)
          // self.grid.push(_.times(self.hotel.cols, _.constant({ombrid: 'new'})))
          // self.grid.push(self.grid[oldval - 1])
          self.grid.push(JSON.parse(JSON.stringify(self.grid[oldval - 1].map(function (o) {
            var id = o.ombrid.split(/([aA-zZ]+)([0-9]+)|([0-9]+)([aA-zZ]+)/).filter((el) => { return (el && el.length > 0) })
            var ombrid
            var idindex
            if (id.length > 1) {
              if (isNaN(id[0]) && !isNaN(id[1])) {
                idindex = _.findIndex(self.alphabet, function (l) { return l == id[0].toLowerCase() })
                ombrid = self.alphabet[idindex + 1 + i].toUpperCase() + id[1]
              }
              if (!isNaN(id[0]) && isNaN(id[1])) {
                // console.log('inverted')
                idindex = _.findIndex(self.alphabet, function (l) { return l == id[1].toLowerCase() })
                // console.log(idindex, idindex + 1)
                ombrid = (parseInt(id[0]) + 1) + id[1].toUpperCase()
              }
            } else {
              if (!isNaN(id[0])) {
                // console.log(o.ombrid.split(/([0-9])([0-9]+)/).filter((el) => { return (el && el.length > 0) }))
                id = o.ombrid.split(/([0-9])([0-9]+)/).filter((el) => { return (el && el.length > 0) })
                ombrid = ((parseInt(id[0]) + 1) + id[1]).toString()
              }
              if (isNaN(id[0])) {
                console.log('adasd')
                idindex = _.findIndex(self.alphabet, function (l) { return l == id[0].toLowerCase() })
                ombrid = self.alphabet[idindex + 1 + i].toUpperCase()
              }
              // ombrid = 1
            }
            // var idindex = _.findIndex(self.alphabet, function (l) { return l == id[0].toLowerCase() })
            console.log(idindex + i)
            console.warn(ombrid)
            return {
              ombrid: ombrid,
              new: true
            }
          }))))
        })
        // self.grid.push(self.grid[oldval - 1])
      } else {
        console.warn('neg row number')
        self.warning = true
        _.forEach(_.range(oldval, newval), function () {
          self.grid.pop()
        })
      }
    },
    show (section) {
      // console.log(section)
      this.$emit('open', section)
    },
    save () {
      console.log('save', this.firsttime)
      console.log(_.flatten(this.grid))
      this.$store.dispatch('hotels/updateGrid', _.flatten(this.grid)).then(() => {
        if (this.firsttime) {
          this.$emit('open', 'dashboard')
        } else {
          this.grid = _.chunk(this.ombrelloni, this.hotel.cols)
        }
      })
    }
  },
  filters: {
    segmentstyle (ombrellone, activehotel) {
      // console.log(ombrellone, activehotel.segments)
      var segmentcolor = _.find(activehotel.segments, {ombrelloni: [{ombrelloneid: ombrellone}]})
      // if (segmentcolor) {
      //   console.log(segmentcolor)
      // }
      if (activehotel.cashier) {
        return {
          color: segmentcolor?.color ? segmentcolor.color : '',
          borderColor: segmentcolor?.color ? segmentcolor.color : ''
        }
      } else {
        return {
          color: '',
        }
      }
    }
  },
  watch: {
    // hotel: {
    //   // immediate: true,
    //   deep: true,
    //   handler (newval, oldval) {
    //     console.log('watch room: ', newval.cols, oldval.cols)
    //     // console.log('watch: ', _.isEqual( newval, this.$store.state.hotels.activehotel))
    //     // this.changes = _.isEqual( newval, this.$store.state.hotels.activehotel)
    //     // if (_.isEqual( newval, this.$store.state.hotels.activehotel)) {
    //     //   this.changes = false
    //     // } else {
    //     //   this.changes = true
    //     // }
    //   }
    // }
  },
  computed: {
    addrow () {
      if (this.grid.length === 1) {
        return true
      } else {
        return false
      }
    },
    // hotel () {
    //   return JSON.parse(JSON.stringify(this.$store.state.hotels.activehotel))
    // },
    hotelloading () {
      return this.$store.state.hotels.loading
    },
    ombrelloni () {
      return _.orderBy(this.$store.state.ombrelloni.ombrelloni, 'sortorder')
    },
    style () {
      // return 'grid-template-columns: repeat(' + this.hotel.cols + ', 1fr); grid-template-rows: repeat(' + this.hotel.rows + ', 1fr)'
      return 'grid-template-columns: repeat(1, 1fr); grid-template-rows: repeat(' + this.hotel.rows + ', 1fr)'
    }
  },
  beforeMount () {
    // this.hotel = JSON.parse(JSON.stringify(this.$store.state.hotels.activehotel))
    if (this.$store.state.ombrelloni.ombrelloni.length === 0) {
      console.log('no2')
      // this.$store.state.ombrelloni.ombrelloni.push({
      //   ombrid: 'A1'
      // })
    }
  },
  mounted () {
    this.grid = _.chunk(this.ombrelloni, this.hotel.cols)
    // this.checkGrid()
    if (this.$store.state.ombrelloni.ombrelloni.length === 0) {
      console.log(this.$refs.firstombrid.focus())
    }
  },
  created () {
    /* eslint-disable */
    this.selection = Selection.create(options)
    this.selection.on('beforestart', evt => {
    
        // Use this event to decide whether a selection should take place or not.
        // For example if the user should be able to normally interact with input-elements you 
        // may want to prevent a selection if the user clicks such a element:
        // selection.on('beforestart', ({oe}) => {
        //   return oe.target.tagName !== 'INPUT'; // Returning false prevents a selection
        // });
        
        // console.log('beforestart', evt);
        // evt.inst.clearSelection()
        if (!evt.oe.shiftKey && !evt.oe.metaKey) {
          // Deselect all elements
          var selectedElements = evt.selected
          selectedElements.forEach(s =>
            s.classList.remove(options.selectedClass)
          )
          // Clear previous selection
          evt.inst.clearSelection()
        }
    }).on('start', function (evt) {

        // A selection got initiated, you could now clear the previous selection or
        // keep it if in case of multi-selection.
        // this.clearSelection()
        var selectedElements = evt.selected
        console.log('start', evt, evt.oe.shiftKey, selectedElements);

        // Remove class if the user is'nt pressing the control key or ⌘ key
        if (!evt.oe.shiftKey && !evt.oe.metaKey) {
          // Deselect all elements
          selectedElements.forEach(s =>
            // console.log(s)
            s.classList.remove(options.selectedClass)
          )
          // Clear previous selection
          evt.inst.clearSelection()
        } else {
          evt.selected.forEach(s => s.classList.add(options.selectedClass))
          // evt.inst.keepSelection()
        }
    }).on('move', evt => {

        // Here you can update elements based on their state.
        // console.log('move', evt);
        // if (!evt.oe.shiftKey || !evt.oe.metaKey) {
        //   // Deselect all elements
        //   evt.selected.forEach(s =>
        //     s.classList.remove(options.selectedClass)
        //   )
        //   // Clear previous selection
        //   evt.inst.clearSelection()
        // } else {
        //   evt.selected.forEach(s => s.classList.add(options.selectedClass))
        // }
        evt.selected.forEach(s => s.classList.add(options.selectedClass))
        // evt.inst.keepSelection()
    }).on('stop', evt => {

        // The last event can be used to call functions like keepSelection() in case the user wants
        // to select multiple elements.
        console.log('stop', evt);
        evt.inst.keepSelection()
        this.selectedOmbrellos = []
        evt.selected.forEach((ombrellone, indexo) => {
          // console.log(ombrellone.dataset)
          this.selectedOmbrellos.push({ombrid: ombrellone.dataset.ombrid, ombrelloneid: ombrellone.dataset.id})
        })
    });
  },
  beforeDestroy () {
    this.selection.destroy()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fade-enter-active {
  transition: opacity .5s;
}
.fade-leave-active {
  transition: opacity 0s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all 0s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(10px);
  opacity: 0;
}
</style>
